const shoppingCodes = [
    'suzano',
    'catuai'
];

export default shoppingCodes;
